/** 28.09 (владелец: «перемещения админа зала должны быть одобрены ОО — и история таких
 *  перемещений должна сохраняться»): заявки админов залов в дашборде ОО. Ждущие — все дни,
 *  ✓ применяет правку (как «Сохранить» доски, человеку — сообщение о нём), ✕ — с причиной.
 *  Ниже — история выбранного дня: кто просил, почему, кто решил, чем кончилось.
 *  Те же заявки решаются кнопками в Telegram (hrok/hrno). */
import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../../api/client";
import { TextPad } from "../../components/shared";
import { fmtDateApi } from "../../utils/date";
import { hhmm } from "../op/HallRequests";
import type { HallReq } from "../../hooks/useHallDay";
import css from "./dashboard.module.css";
import h from "../op/hallAdmin.module.css";

type Row = HallReq & { date: string; branch_id: string };
const STATUS: Record<HallReq["status"], string> = { pending: "ждёт", approved: "одобрено", rejected: "отклонено", failed: "не применилось", cancelled: "отозвано" };

export function HallRequestsBlock({ date }: { date: Date }) {
  const [data, setData] = useState<{ pending: Row[]; day: Row[] }>({ pending: [], day: [] });
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((n) => n + 1), []);
  const [busy, setBusy] = useState<number | null>(null); const lock = useRef(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [rejectFor, setRejectFor] = useState<Row | null>(null);
  const [histOpen, setHistOpen] = useState(false);
  const d = fmtDateApi(date);
  useEffect(() => {
    let alive = true;
    api<{ pending: Row[]; day: Row[] }>(`/api/assignments/hall-requests?date=${d}`).then((r) => { if (alive) setData(r); }).catch(() => {});
    return () => { alive = false; };
  }, [d, tick]);
  const decide = (r: Row, approve: boolean, note = "") => {
    if (lock.current) return; lock.current = true; setBusy(r.id); setMsg(null);
    void api<{ ok: boolean; status?: string; error?: string }>(`/api/assignments/hall-requests/${r.id}/decide`, { method: "POST", body: { approve, note } })
      .then((res) => setMsg(res.status === "failed" ? `Не применилось: ${res.error ?? ""}` : null))
      .catch((e: unknown) => setMsg(e instanceof Error ? e.message : "Не получилось"))
      .finally(() => { lock.current = false; setBusy(null); reload(); });
  };
  if (!data.pending.length && !data.day.length) return null;
  const dm = (iso: string) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
  return (
    <section className={css.brief}>
      <div className={css.briefRow}><span className={css.briefLbl}>Заявки админов залов</span><span className={css.briefStat}><b>{data.pending.length}</b></span></div>
      {data.pending.length ? <div className={css.propLegend}>✓ одобрить — правка применится и человеку уйдёт сообщение · ✕ отклонить</div> : null}
      {msg ? <div className={h.warn}>{msg}</div> : null}
      {data.pending.map((r) => (
        <div key={r.id} className={`${h.req} ${h.st_pending}`}>
          <div className={h.reqHead}>
            <span className={h.reqText}>{r.summary}</span>
            <button type="button" className={`${css.propAct} ${css.propOk}`} disabled={busy === r.id} title="Одобрить" onClick={() => decide(r, true)}>✓</button>
            <button type="button" className={`${css.propAct} ${css.propNo}`} disabled={busy === r.id} title="Отклонить" onClick={() => setRejectFor(r)}>✕</button>
          </div>
          <div className={h.reqMeta}>{r.branch_id.toUpperCase()} {dm(r.date)} · админ {r.requested_by_name} {hhmm(r.requested_at)}{r.note ? ` · «${r.note}»` : ""}</div>
        </div>
      ))}
      {data.day.length ? (
        <button type="button" className={h.toggle} onClick={() => setHistOpen((o) => !o)} aria-expanded={histOpen}>
          История дня <span className={h.cnt}>({data.day.length})</span> {histOpen ? "▴" : "▾"}
        </button>
      ) : null}
      {histOpen ? data.day.map((r) => (
        <div key={r.id} className={`${h.req} ${h[`st_${r.status}`] ?? ""}`}>
          <div className={h.reqHead}><span className={h.reqText}>{r.summary}</span><span className={h.reqStatus}>{STATUS[r.status]}</span></div>
          <div className={h.reqMeta}>
            {r.branch_id.toUpperCase()} · админ {r.requested_by_name} {hhmm(r.requested_at)}{r.note ? ` · «${r.note}»` : ""}
            {r.decided_by_name ? ` → ${r.decided_by_name} ${hhmm(r.decided_at)}` : ""}{r.decision_note ? ` · ${r.decision_note}` : ""}{r.apply_result ? ` · ${r.apply_result}` : ""}
          </div>
        </div>
      )) : null}
      <TextPad open={!!rejectFor} label="Почему отклонить (увидит админ)" multiline maxLength={200} value=""
        onCommit={(v) => { if (rejectFor) decide(rejectFor, false, v.trim()); }} onClose={() => setRejectFor(null)} />
    </section>
  );
}
